export default __webpack_public_path__ + "assets/elichens-logo-small-all-white.38e0b44c.svg";